// extracted by mini-css-extract-plugin
export default {"searcher":"Searcher_searcher__sHwzY"};